import clsx from "clsx";
import { BLOCKS } from "@contentful/rich-text-types";
import { useRouter } from "next/router";
import Icon from "@Components/ui/icon";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { ICookingDirectionsContent } from "@Types/recipes-detail-page";
import classes from "./RecipesDetail.module.scss";

interface CookingDirectionsProps extends ICookingDirectionsContent {}

export const CookingDirections = (props: CookingDirectionsProps) => {
  const renderingOptions = {
    renderNode: {
      [BLOCKS.LIST_ITEM]: (_node: any, children: string) => {
        return <DirectionItem>{children}</DirectionItem>;
      },
    },
  };

  return (
    <div className={classes["cooking-directions"]}>
      <h2>{props["recipe.page.cookingDirections"]}</h2>
      <CmsTextEditorContent
        content={props.cookingdirections}
        options={{
          ...renderingOptions,
        }}
      />
    </div>
  );
};

interface DirectionItemProps {
  children?: React.ReactNode;
}

const DirectionItem = (props: DirectionItemProps) => {
  const {
    query: { viewMode },
  } = useRouter();

  return (
    <li
      className={clsx(
        classes["direction-item"],
        viewMode === KIOSK_VIEW_MODE_QUERY && classes.kiosk
      )}
    >
      <div className={classes["question-bullet"]}>
        <Icon iconName="question-bullet" />
      </div>
      {props.children}
    </li>
  );
};
